import { render, staticRenderFns } from "./usualPlayerItem.vue?vue&type=template&id=35ed62a0&scoped=true&"
import script from "./usualPlayerItem.vue?vue&type=script&lang=js&"
export * from "./usualPlayerItem.vue?vue&type=script&lang=js&"
import style0 from "./usualPlayerItem.vue?vue&type=style&index=0&id=35ed62a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed62a0",
  null
  
)

export default component.exports